import toast from '@/common/toast';

const timeoutMessage = 'Unable to connect to Rebilly. Please verify your internet connection and try again. If the issue persists please contact support.';

/**
 * Setup api timeout error handler
 * dispatch logout on api timeout error.
 * @param {Object} api
 * @param {Object} store
 */
export default function timeoutMiddleware({api, store}) {
    api.setupTimeoutErrorResponseInterceptor({
        timeoutMessage,
        store,
        callback: ({store: injectedStore}) => {
            if (injectedStore.getters['user/isGuest']
                || injectedStore.getters['user/isSessionExpired']) {
                // ignore guest
                return;
            }
            // dispatch logout on timeout error
            injectedStore.dispatch('app/logout');
            setTimeout(
                () => toast.negative(
                    timeoutMessage,
                    {delay: 10000},
                ),
                500,
            );
        },
    });
}
